import {
  ACCEPTED,
  CANCELED,
  DECLINED,
  TIMEOUT,
  AlertStatusName,
} from '@rsos/constants/alertStatuses';

export const shouldShowAlertActions = (
  alertStatus: AlertStatusName | undefined,
): boolean => {
  return alertStatus !== ACCEPTED;
};

export const shouldShowRemoveAlert = (
  alertStatus: AlertStatusName | undefined,
  isSupplementalOnly: boolean | undefined,
): boolean => {
  return (
    !!isSupplementalOnly ||
    (alertStatus !== undefined &&
      [CANCELED, DECLINED, TIMEOUT].includes(alertStatus))
  );
};
